export class CulturalElevatorAccessMapper {
    public static toLabel(type?: string | null): string {
        switch (type) {
            case 'no_elevator': {
                return 'Nein, es gibt keinen Aufzug';
            }
            case 'limited_elevator': {
                return 'Ja, es gibt einen Aufzug, der aber nicht für alle Rollstühle geeignet ist';
            }
            case 'yes_elevator': {
                return 'Ja, es gibt einen rollstuhlgerechten Aufzug';
            }
            case undefined:
            case null:
            default:
                return 'Nicht bekannt';
        }
    }
}
